/*
Copyright 2024 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

export const MAPBOX_ACCESS_TOKEN = "pk.eyJ1Ijoiamp3dy1pb2R5bmUiLCJhIjoiY20ybm1qMHBlMDdrZTJrcHR5cHpvZjBkcyJ9.LkkqAA31yrUK0Q2LBagQpQ";
export const MAPBOX_DEFAULT_OPTIONS:{
    center: [number, number],
    style: string,
    zoom: number,
    maxZoom: number
} = {
    center: [-122.545, 37.906],
    style: "mapbox://styles/jjww-iodyne/cm2nm7xpu000d01pta2c1erwi",
    zoom: 10,
    maxZoom: 20
}
export const IPINFO_ACCESS_TOKEN = "a21d828700ca6c"